import type { VariantProps } from "class-variance-authority";
import type { SVGProps } from "react";

import { cn } from "@homeinstead/ui";
import { cva } from "class-variance-authority";
import React from "react";
import CheckSVG from "./check.svg";

const checkStyles = cva("", {
  defaultVariants: {
    variant: "default",
  },
  variants: {
    variant: {
      default: "stroke-clear-sky-base",
      disc: "rounded-full bg-new-beginnings-base",
    },
  },
});

export interface CheckProps
  extends SVGProps<SVGSVGElement>,
    VariantProps<typeof checkStyles> {
  className?: string;
}

export default function Check({ className, variant, ...props }: CheckProps) {
  return (
    <CheckSVG className={cn(checkStyles({ className, variant }))} {...props} />
  );
}
